const t="msdf",m="bitmap";export{m as FONT_BITMAP,t as FONT_MSDF};
